import type { MouseEvent, ReactNode } from "react";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

/** Primary list affordance — click the doc number to open (ERPNext-style). */
export function DocNumberLink(props: {
  to: string;
  children: ReactNode;
  className?: string;
  /** Call preventDefault to keep the list (e.g. desk glance peek). */
  onClick?: (e: MouseEvent<HTMLAnchorElement>) => void;
}) {
  return (
    <Link
      to={props.to}
      onClick={(e) => props.onClick?.(e)}
      className={cn(
        "font-medium font-mono text-sm text-[var(--color-primary)] no-underline hover:underline",
        props.className,
      )}
    >
      {props.children}
    </Link>
  );
}
